import React, {useEffect, useState} from 'react';
import './UserAccount.css';
import ProfileHeader from "../Profile/ProfileHeader/ProfileHeader";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import ChangePassword from "../../Components/Menu/MenuOptions/ChangePassword/ChangePassword";
import RegisterAccept from "../Registration/RegisterAccept/RegisterAccept";

const UserAccount = () => {

    const navigate = useNavigate();
    const [isChangeModalOpen, setIsChangeModalOpen] = useState(false);
    const [isRulesModalOpen, setIsRulesModalOpen] = useState(false);

    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [name, setName] = useState('');

    useEffect(() => {
        axios.get(`/api/profile/`, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                // 'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                setEmail(res.data.detail.email);
                setPhone(res.data.detail.phone_number);
                setName(res.data.detail.name);
            })
            .catch(e => {
                console.log(e);
            })
    }, [setEmail, setPhone, setName]);

    const deleteAccount = () => {

        if (window.confirm('Удаление аккаунта приведёт к потере всех данных, связанных с аккаунтом, по истечении 10 дней. Удалить?')) {
            axios.get(`/api/del_account/`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Headers': 'X-CSRFToken'
                    }, withCredentials: true
                }
            )
                .then(res => {
                    if (res.status === 200) {
                        alert('Профиль успешно удалён');
                        navigate('/login', {replace: true});
                    }
                })
                .catch(e => {
                    console.log(e);
                })
        }

    }

    const openChangeModal = () => {
        setIsChangeModalOpen(true);
    }

    const openRulesModal = () => {
        setIsRulesModalOpen(true);
    }

    return (
        <div className={'user-account-page'}>
            <ProfileHeader isWhite={false}/>

            <div className={'user-account-title'}>Мой профиль</div>

            <div className={'user-account-data'}>
                <div className={'user-account-data-block'}>
                    <p className={'user-account-data-block-text'}>e-mail:</p>
                    <input type={'text'} className={'user-account-data-block-input'} value={email}/>
                </div>
                <div className={'user-account-data-block'}>
                    <p className={'user-account-data-block-text'}>телефон:</p>
                    <input type={'tel'} className={'user-account-data-block-input'} value={phone}/>
                </div>
                <div className={'user-account-data-block'}>
                    <p className={'user-account-data-block-text'}>имя:</p>
                    <input type={'tel'} className={'user-account-data-block-input'} value={name}/>
                </div>
            </div>

            <div className={'user-account-button-container'}>
                <div className={'user-account-button user-account-rules'}
                     onClick={() => openRulesModal()}>Правила
                </div>
            </div>
            <div className={'user-account-button-container'}>
                <div className={'user-account-button user-account-change-pass'}
                     onClick={() => openChangeModal()}>Сменить пароль
                </div>
            </div>
            <div className={'user-account-button-container'}>
                <div className={'user-account-button user-account-delete-acc'} onClick={() => deleteAccount()}>Удалить
                    профиль
                </div>
            </div>

            <ChangePassword
                isOpen={isChangeModalOpen}
                onRequestClose={setIsChangeModalOpen}
            />

            <RegisterAccept
                isOpen={isRulesModalOpen}
                onRequestClose={setIsRulesModalOpen}
            />
        </div>
    );
};

export default UserAccount;